<script setup>
import { close_button_ui_styles, modal_ui_styles } from '@/utilities/ui'

const { $bus } = useNuxtApp();

const open = defineModel('open')
const router = useRouter()
const route = useRoute()

const copy = computed(() => {
    if (route.query.action === 'favorite') {
        return 'In order to favorite a session, You must log in using the email you registered with and your ticket confirmation number.'
    }
    if (route.query.action === 'reservations') {
        return 'In order to reserve a seat for a session, You must log in using the email you registered with and your ticket confirmation number.'
    }    
    if (route.query.action === 'braindate') {
        return 'Please login with the email you used to register for INBOUND and your ticket number. You’ll be logged into INBOUND.com and automatically redirected to Braindate.'
    }    
    return 'You must log in using the email you registered with and your ticket confirmation number.'
})

const headline = computed(() => {
    if (route.query.action === 'braindate') {
        return 'You must be logged into INBOUND.com to use Braindate'
    }    
    return 'Login'
})

watch(open, (val) => {
    if (val) { $bus.emit('drawer-open'); }
    else {
        $bus.emit('drawer-close');
        const currentQuery = { ...route.query };
        delete currentQuery.modal;
        delete currentQuery.action;
        router.replace({ query: currentQuery });
    }
})
</script>

<template>
    <UModal v-model:open="open" title="Login" :ui="modal_ui_styles" :dismissable="false" :close="close_button_ui_styles">
        <template #body>
            <FragmentsAuthForm :next-step="nextStep" v-model:open="open" :copy="copy" :headline="headline" />
        </template>
    </UModal>
</template>